import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, signal } from '@angular/core';
import { TextSeo } from '@components/text-seo/model';
import { UrlService } from '@services/url';
import { map } from 'rxjs';

@Component({
  selector: 'app-text-seo',
  templateUrl: './text-seo.component.html',
  styleUrl: './text-seo.component.scss',
  imports: [NgClass, AsyncPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextSeoComponent {
  @Input() data!: TextSeo;

  isHidden = signal(true);
  isDisplayed$ = inject(UrlService)
    .getParams()
    .pipe(map((params) => !(params && params['page'] && Number(params['page']) > 1)));
}
